import React, { FC, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../redux/store";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../../components/reusable-ui/material-ui-comp/accordion";
import InvoiceSummary from "../invoice-summary";
import { getCumulativeSum } from "../../../../helpers/accounting-helper";
import {
  getInvoiceDetails,
  getUserCreditDetails,
} from "../../../../redux/slices";
import SortFilter from "../sort-filter";
import SearchInputComponent from "../../../../components/reusable-ui/search-input";
import { ACCOUNT_SUMMARY, GROUP_BY_TYPES, SORT_VALUE_TYPES } from "../../../../data/constants";
import { allowEverything } from "../../../../utils/regex";
import ZeroScreen from "../zero-screen";
import { isMobileTabDevice } from "../../../../helpers/device-info-helper";
import { renderAccordionHeader } from "./accordion-header";
import { getGroupedData } from "../payment-summary/payment-summary-details";
import { renderBillDetails } from "./credit-sumary-details";
interface Props {
  selectedDate: string;
  branchIds: any;
  brandName: any;
  groupBy: string;
  hideFilterMobile: any;
  showFilterResults: any;
}
interface DataItem {
  totalBalance: number;
  customerRefId: number;
  branchId: string;
  customerId: string;
  name: string;
}

const dropdownItems = [
  {
    key: "amountl2h",
    label: "Amount (Low to High)",
    getKey: (val: any) => {
      return getCumulativeSum(val, "totalBalance");
    },
    type: SORT_VALUE_TYPES.number,
    class: "ic-sort-increasing",
  },
  {
    key: "amounth2l",
    label: "Amount (High to Low)",
    getKey: (val: any) => {
      return -getCumulativeSum(val, "totalBalance");
    },
    type: SORT_VALUE_TYPES.number,
    class: "ic-sort-decreasing"
  },
];

const dropdownItemsBill = [
  {
    key: "amountl2h",
    label: "Amount (Low to High)",
    getKey: (val: any) => {
      return val.saleAmount;
    },
    type: SORT_VALUE_TYPES.number,
    class: "ic-sort-increasing",
  },
  {
    key: "amounth2l",
    label: "Amount (High to Low)",
    getKey: (val: any) => {
      return -val.saleAmount;
    },
    type: SORT_VALUE_TYPES.number,
    class: "ic-sort-decreasing"
  },
];

const CreditSummary: FC<Props> = ({
  selectedDate,
  branchIds,
  brandName,
  groupBy,
  hideFilterMobile,
  showFilterResults
}) => {
  const [invoiceSummary, setInvoiceSummary] = useState<boolean>(false);
  const [saleId, setSaleId] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<any>({});
  const [searchIcon, setSearchIcon] = useState<boolean>(false);
  const [searchData, setSearchData] = useState<any>({
    value: "",
    results: [],
  });
  const [selectedCustomerData, setSelectedCustomerData] = useState<any>({});
  const [billsDetailsMap, setBillsDetailsMap] = useState<any>({});
  const [creditSummaryData, setCreditSummaryData] = useState<any>({});
  const dispatch = useDispatch();

  const { businessBranchesDataMap, creditSummaryDataList, billsDetails } =
    useSelector((state: any) => ({
      creditSummaryDataList: state.accountingReducer.creditSummary,
      businessBranchesDataMap: state.businessReducer.businessBranchesDataMap,
      billsDetails: state.accountingReducer?.userCreditDetails,
    }));

  useEffect(() => {
    if (billsDetails?.length > 0) setBillsDetailsMap(billsDetails);
  }, [billsDetails]);

  useEffect(() => {
    setCreditSummaryData(
      getGroupedData(
        creditSummaryDataList,
        groupBy === GROUP_BY_TYPES.branch ? "branchId" : "bizBrandName"
      )
    );
    setSelectedCustomerData("");
  }, [creditSummaryDataList]);

  const handleUserDataChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      event.stopPropagation();
      setSelectedUser(newExpanded ? panel : false);
    };
  const handleInvoiceSummary = () => {
    setInvoiceSummary(!invoiceSummary);
    setSaleId("");
  };


  const onSearchInput = (searchStr: string) => {
    const results: any = [];
    if (searchStr && billsDetailsMap) {
      for (let key of Object.keys(billsDetailsMap)) {
        if (
          billsDetailsMap[key].billNumber
            .toLocaleLowerCase()
            .includes(searchStr.toLocaleLowerCase())
        ) {
          results.push(billsDetailsMap[key]);
        }
      }
    }
    setSearchData({ value: searchStr, results });
  };

  function fetchInvoiceDetails(saleId: string) {
    setSaleId(saleId);
    dispatch(getInvoiceDetails({ saleId }));
  }

  function renderCreditItems(options: any, index: string) {
    return Object.values(options)?.length
      ? Object.values(options[index]).map((option: any, i: number) => {
        let dataToPost = {
          branchIds: (groupBy === GROUP_BY_TYPES.branch
            ? [option?.branchId]
            : branchIds),
          customerRefId: option?.customerRefId,
          periods: [{ startDate: selectedDate }],
          bizzBrandNames:groupBy === GROUP_BY_TYPES.brand
          ? [option?.bizBrandName]
          : brandName,  
          groupBy: groupBy,
          isNew: true,
        };
          return (
            <section
              className={`p-16 pl-50 hover:shadow-[0px_2px_4px_#00000014] relative flex items-center cursor-pointer w-full border-b-[1px]  border-b-[#ECECEC] menu-item-details ${
                selectedCustomerData.customerRefId === option.customerRefId
                  ? "bg-[#0000001a] border-l-[3px] border-l-[#000]"
                  : ""
              }`}
              key={i}
              onClick={() => {
                setSelectedCustomerData(option);
                hideFilterMobile(option);
                dispatch(getUserCreditDetails(dataToPost));
              }}
            >
              <div className="flex justify-between w-[100%]">
                <div className="flex flex-col font-normal">
                  <p className="text-[1.10rem]">{option?.name || "Others"}</p>
                  <p className="text-13 opacity-50">
                    CustomerId: {option?.customerRefId || "NA"}
                  </p>
                </div>
                <div className="text-[14px] smd:pr-[12px] text-[#3A5E8B] flex items-center">
                  <span>Amount Receivable:</span>
                  <span className="ml-5 font-semibold">
                    ₹{Number(option?.totalBalance).toFixed(2)}
                  </span>
                </div>
              </div>
            </section>
          );
        })
      : null;
  }

  function renderSearchResults(): JSX.Element {
    return searchData.results.length ? (
      <>
      {searchIcon &&
        <div className="text-14 font-normal p-16 opacity-50 border-b-[1px] border-[#ECECEC]">
          {searchData.results.length} results found
        </div>}
        {renderBillDetails(
          searchData.results,
          setInvoiceSummary,
          fetchInvoiceDetails
        )}
      </>
    ) : (
      <div className="flex flex-col justify-center items-center w-full mt-56">
        <div className="flex items-center justify-center w-[72px] h-[72px] bg-opacity-5 bg-[#000] rounded-[8px]">
          <div className="rista-sprite ic-not-found"></div>
        </div>
        <p className="text-20 font-semibold mt-24 mb-6 opacity-40">
          No results found
        </p>
        <p className="text-13 font-normal mb-6 opacity-40 mt-[0px]">
          Please try using other name or keyword
        </p>
      </div>
    );
  }

  function renderOptionSetsList(optionSetsList: any) {
    return Object.keys(optionSetsList).length > 0
      ? Object.keys(optionSetsList).map((optionSet: any, i: number) => {
          return (
            <Accordion
              key={optionSet}
              TransitionProps={{ unmountOnExit: true }}
              expanded={selectedUser === optionSet}
              onChange={handleUserDataChange(optionSet)}
            >
              <AccordionSummary
                className={`accordion-header flex justify-between !hover:shadow-[0px_2px_4px_#00000014] !p-16 smd:!py-16 smd:!pr-16 smd:!pl-12 ${
                  optionSet === selectedUser ? "active" : ""
                }`}
                id={optionSet}
              >
                {renderAccordionHeader({
                  headerName:
                    businessBranchesDataMap[optionSet]?.branchName || optionSet,
                  groupBy: groupBy,
                  option: creditSummaryData[optionSet],
                  businessBranchesDataMap: businessBranchesDataMap,
                  itemCount: Object.values(optionSetsList[optionSet])?.length,
                  itemPrice: getCumulativeSum(
                    Object.values(optionSetsList[optionSet]),
                    "totalBalance"
                  ),
                })}
              </AccordionSummary>
              <AccordionDetails>
                {renderCreditItems(optionSetsList, optionSet)}
              </AccordionDetails>
            </Accordion>
          );
        })
      : null;
  }

  function renderAmountHeader(): JSX.Element {
    return (
      <div className="smd:w-[100%] w-[40%] border-r-[1px] mt-12 ml-16 smd:mt-0 smd:ml-0 smd:m-0">
        <div className="flex border-b-[1px] bg-white py-15">
          <div className="bg-white pl-20 pr-15 border-r-[1px] basis-1/2">
            <span className="text-[#0000007A] text-[14px] font-normal">Amount Recievable</span>
            <br />
            <span className="text-black text-[17px] font-semibold">
              ₹{Number(getCumulativeSum(creditSummaryDataList, "totalBalance")).toFixed(2)}
            </span>
          </div>
          <div className="bg-white pl-20 pr-15 basis-1/2">
            <span className="text-[#0000007A] text-[14px] font-normal">Customer Count</span>
            <br />
            <span className="text-black text-[17px] font-semibold">{creditSummaryDataList.length}</span>
          </div>
        </div>
        <div className="text-[#0000007A] bg-white text-xs py-12 px-16 flex items-center justify-between border-b-[1px]">
          <div className="text-[14px] font-semibold">
            {" "}
            {groupBy === GROUP_BY_TYPES.branch ? "Branches:" : "Brands:"}
            {Object.keys(creditSummaryData).length}
          </div>
          <SortFilter
            dataToSort={Object.values(creditSummaryData)}
            handleSort={setCreditSummaryData}
            sortOptionsMap={dropdownItems}
          />
        </div>
        <div className="h-[calc(100vh-312px)] overflow-y-auto pb-[8px]">
          {renderOptionSetsList(creditSummaryData || [])}
        </div>
      </div>
    );
  }

  function renderInvoiceHeader(): JSX.Element{
    return (
      <>
        {billsDetails?.length > 0 && (
          <div className="sale-summary-container border border-[#DDDDDD] m-24 rounded-[12px] p-4 smd:m-20">
            <div className="relative pt-[74px] h-[100%]">
              <div
                className={`sale-summary-header flex justify-between items-center px-20 py-15 border-b border-[#DDDDDD]`}
              >
                {!searchIcon ? (
                  <>
                    <div className="flex smd:flex-col items-start justify-center">
                      <div className="flex">
                        {isMobileTabDevice() && (
                          <div
                            className="rista-sprite ic-back-icon smd:items-center smd:justify-center cursor-pointer"
                            onClick={() => {
                              setSelectedCustomerData({});
                              hideFilterMobile({});
                            }}
                          ></div>
                        )}
                        <div className="flex-1 text-20 sm:text-[17px] font-inter font-semibold line-clamp-1">
                          {selectedCustomerData?.name || "Others"}
                        </div>
                      </div>
                      <div className="flex sm:text-[12px]">
                        <p className="!ml-5 text-[#0000007A] border-r-2 pr-3 mt-6">
                          <span>{billsDetails?.length}</span>
                          <span className="ml-2">Payments</span>
                        </p>
                        <p className="text-[#0000007A] px-3 pt-6">
                          <span>
                            ₹
                            {Number(
                              getCumulativeSum(billsDetails, "saleAmount")
                            ).toFixed(2)}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="flex">
                      <div
                        className="w-[38px] mr-12 text-[13px] h-[38px] border border-[#3a5e8b1a] hover:border-black cursor-pointer rounded-[6px] flex gap-1.25 justify-center items-center overflow-hidden"
                        onClick={() => setSearchIcon(true)}
                      >
                        <span className="w-[18px] rista-sprite ic-search-icon ml-[1%]"></span>
                      </div>
                      <SortFilter
                        dataToSort={billsDetails}
                        handleSort={setBillsDetailsMap}
                        sortOptionsMap={dropdownItemsBill}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <SearchInputComponent
                      placeholder={"Search..."}
                      customClass={"text-15 py-12 outline-[#9FCAFD]"}
                      onSerachInput={onSearchInput}
                      searchMinLength={3}
                      regexCheck={allowEverything}
                      elementWidthClass={"w-[90%]"}
                      autoFocus={true}
                    />
                    <span
                      className="rista-sprite ic-cross-black"
                      onClick={() => setSearchIcon(false)}
                    ></span>
                  </>
                )}
              </div>
              <div className="sale-summary-body">
                {searchData.value.length >= 3
                  ? renderSearchResults()
                  : renderBillDetails(
                      billsDetailsMap ? Object.values(billsDetailsMap) : [],
                      setInvoiceSummary,
                      fetchInvoiceDetails
                    )}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  function renderCreditSummary(): JSX.Element {
    //condition to check before showing credit summary
    let isRenderCreditSummary =
      (Object.values(creditSummaryData).length > 0 && !isMobileTabDevice()) ||
      (isMobileTabDevice() && Object.values(selectedCustomerData).length === 0); 
    return (
      <div className={`flex smd:flex-col`}>
        {isRenderCreditSummary && renderAmountHeader()}
        <div className="w-[60%] bg-white mr-16 mt-12 smd:mt-0 smd:w-[100%]">
          {" "}
          {!invoiceSummary && Object.values(selectedCustomerData).length > 0
            ? renderInvoiceHeader()
            : !invoiceSummary &&
              !isMobileTabDevice() && (
                <ZeroScreen
                  showSummaryDetails={true}
                  summaryType={ACCOUNT_SUMMARY.credit.id}
                />
              )}
          {invoiceSummary && (
            <InvoiceSummary closeInvoiceDetails={handleInvoiceSummary} />
          )}
        </div>
      </div>
    );
  }
  return (
    <>
      {Object.values(creditSummaryData).length > 0 ? (
        renderCreditSummary()
      ) : (
        <ZeroScreen showFilterResults={showFilterResults} />
      )}
    </>
  );
};
export default CreditSummary;
